import React, { useContext } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Logo from '../pylo.png';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../context/GlobalStore';
import { Box, Typography, Divider } from '@mui/material';
import ToggleDatabase from './ToggleDatabase';

const Header = (props) => {
  const { signOut } = props;
  const { state } = useGlobalContext();
  return (
    <AppBar
      position="fixed"
      sx={{
        background: '#fff',
        color: 'primary.main',
        zIndex: 10,
        '& .MuiPaper-root': { zIndex: 10 },
      }}
      elevation={1}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        {/* <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton> */}
        <Box display="flex" alignItems="center" gap={2}>
          <Link to="/">
            <img src={Logo} alt="Prevounce logo" style={{ height: 50, display: 'block' }} />
          </Link>
          <Divider orientation="vertical" flexItem sx={{ mx: 1.5, height: 32, alignSelf: 'center', borderRightWidth: '2px' }} />
          <ToggleDatabase />
        </Box>
        <Box display="flex" alignItems="center" gap={2}>
          <Box display="flex">
            <Typography variant="body1" mr={1}>
              {' '}
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              {state?.account?.authenticated_user?.email}
            </Typography>
          </Box>
          <Divider orientation="vertical" flexItem sx={{ mx: 1.5, height: 32, alignSelf: 'center', borderRightWidth: '2px' }} />
          <Button 
            component="a" 
            href="https://docs.pylo.com/#introduction" 
            target="_blank" 
            rel="noopener noreferrer" 
            color="primary"
            // sx={{ mr: 2 }} // Margin removed as Divider will provide spacing
          >
            Developer Docs
          </Button>
          <Divider orientation="vertical" flexItem sx={{ mx: 1.5, height: 32, alignSelf: 'center', borderRightWidth: '2px' }} />
          <Button color="primary" onClick={signOut} variant="outlined">
            Log out
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
